import {
  IGenerateStrategyProps,
  IStrategy,
  IStrikeData,
  Leg,
  ViewType,
} from "../../../types";
import { analyzePositions } from "../../analyzeProfits";

export const generateBearPutLadder = (
  params: IGenerateStrategyProps,
  data: IStrikeData[],
  strategies: IStrategy[],
  expiryDuration: number
): IStrategy[] => {
  for (let i = data.length - 1; i >= 0; i--) {
    for (let j = i - 1; j > 0; j--) {
      for (let k = j - 1; k > 1; k--) {
        const legs: Leg[] = [
          {
            strikePrice: data[i].strikePrice,
            call: false,
            buy: false,
            quantity: -params.lotSize,
            price: data[i].PE?.lastPrice || 0,
          },
          {
            strikePrice: data[j].strikePrice,
            call: false,
            buy: true,
            quantity: params.lotSize,
            price: data[j].PE?.lastPrice || 0,
          },
          {
            strikePrice: data[k].strikePrice,
            call: false,
            buy: true,
            quantity: params.lotSize,
            price: data[k].PE?.lastPrice || 0,
          },
        ];
        const analysis = analyzePositions(legs);
        const approxMargin =
          legs[1].price * legs[1].quantity +
          legs[2].price * legs[2].quantity +
          params.marginBenefit;
        const strategy: IStrategy = {
          title:
            "Bear Put Ladder " +
            data[i].strikePrice +
            " - " +
            data[j].strikePrice +
            " - " +
            data[k].strikePrice,
          legs: legs,
          putBreakEven: analysis.breakEven.putBreakEven,
          putBreakEvenPercentage:
            ((analysis.breakEven.putBreakEven - params.data.underlyingValue) /
              params.data.underlyingValue) *
            100,
          maxLoss: analysis.maxLoss,
          maxProfit: analysis.maxProfit,
          riskRewardRatio: analysis.maxProfit / analysis.maxLoss,
          maxLossROI: (analysis.maxLoss / approxMargin) * 100,
          maxProfitROI: (analysis.maxProfit / approxMargin) * 100,
          approxMargin: approxMargin,
          expiryDuration: expiryDuration,
          lotSize: params.lotSize,
          types: [ViewType["Extremely Negative"]],
          alert:
            (analysis.maxLoss / approxMargin) * 100 > 15
              ? "Max loss greater than 15% of required capital"
              : "",
        };
        if (
          legs[0].price > 0 && //avoid non-liquid options
          legs[1].price > 0 &&
          legs[2].price > 0
        )
          strategies.push(strategy);
      }
    }
  }
  return strategies;
};